import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AddressInput, CreateCancelButtons, InputMain, PhoneInput2 } from 'components';
import { FindError, FindLoad, FindSuccess, isEmptyObj, useModal } from 'utils';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, payerActions } from 'store';
import { Svg } from 'assets';

export const AddPayer = ({ info, afterSuccess }) => {
  const dispatch = useDispatch();
  const { handleSubmit, control, getValues, setValue, clearErrors, setError, reset } = useForm();
  const { close } = useModal();
  const ACTION_TYPE = info ? 'EDIT_PAYER' : 'ADD_PAYER';
  const loading = FindLoad(ACTION_TYPE);
  const success = FindSuccess(ACTION_TYPE);
  const beckError = FindError(ACTION_TYPE);

  useEffect(() => {
    if (success?.type) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      afterSuccess();
      close();
    }
  }, [success]);

  useEffect(() => {
    if (info) {
      reset({
        ...info,
      });
    }
  }, [info]);

  useEffect(() => {
    if (beckError?.error?.length) {
      if (beckError?.error?.includes('phone must be a valid phone number')) {
        setError('phone', {
          message: 'Phone must be a valid phone number',
        });
      }
    }
  }, [beckError?.error]);

  useEffect(() => {
    return () => {
      clearErrors();
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    };
  }, [success]);

  const onSubmit = (data) => {
    const params = {
      ...data,
    };

    if (isEmptyObj(params?.address)) {
      delete params?.address;
    }

    if (info) {
      dispatch(payerActions.editPayer(info?.id, params));
    } else {
      dispatch(payerActions.addPayer(params));
    }
  };
  return (
    <form className="add-payer-modal-wrapper" onSubmit={handleSubmit(onSubmit)}>
      <div className="modal-header-main">
        <h3 className="modal-header-title">{info ? 'Edit' : 'Add'} Payer</h3>

        <button className="modal-close-btn-main" type="button" onClick={close}>
          <Svg.CloseSvg />
        </button>
      </div>

      <div className="modal-body-main flex-column">
        <InputMain
          name="displayName"
          placeholder="Ex. Medicare"
          control={control}
          labelHeader="Display Name"
          rules={{
            required: 'Display Name is required',
          }}
        />

        <InputMain
          name="name"
          placeholder="Ex. MEDICARE PACE"
          control={control}
          labelHeader="Sync Name"
          rules={{
            required: 'Sync Name is required',
          }}
          helperText={
            <>
              Must exactly match the PACE Center value in the imported Excel file.
              {info ? ' Changing it will break the link with the existing Excel rows.' : ''}
            </>
          }
        />

        <PhoneInput2
          label="Phone Number"
          placeholder={'ex (000) 000-0000'}
          name="phone"
          control={control}
          labelHeader="Phone Number"
          rules={{
            minLength: {
              value: 10,
              message: 'Please enter a valid 10 digit number.',
            },
            validate: (value) => {
              return value ? value?.replace(/[^0-9]/g, '').length === 10 || 'Please enter a valid phone number.' : true;
            },
          }}
        />
        <AddressInput control={control} allValues={getValues()?.address} setValue={setValue} />
      </div>

      <CreateCancelButtons createText={info ? 'Save' : 'Add'} loading={!!loading?.length} />
    </form>
  );
};
